import { API_OPTIONS } from "../utils/constant";
import { useDispatch,useSelector} from "react-redux";
import { addPopularMovies } from "../utils/movieSlice";
import { useEffect } from "react";

const usePopularMovies = () => {
	const dispatch = useDispatch();
	const popularMovies=useSelector((store)=>store.movies.popularmovies)
	const popularmovies = async () => {
		const data = await fetch(
			"https://api.themoviedb.org/3/movie/popular?page=1",
			API_OPTIONS
		);
		const json = await data.json();
		dispatch(addPopularMovies(json.results));
	};

	useEffect(() => {
		if(!popularMovies)popularmovies();
	}, []);
};

export default usePopularMovies;
